import { render, staticRenderFns } from "./visualizacaoEdicao.vue?vue&type=template&id=10ccbd3c&scoped=true"
import script from "./visualizacaoEdicao.vue?vue&type=script&lang=js"
export * from "./visualizacaoEdicao.vue?vue&type=script&lang=js"
import style0 from "./visualizacaoEdicao.vue?vue&type=style&index=0&id=10ccbd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ccbd3c",
  null
  
)

export default component.exports